import _styled from "@emotion/styled-base";
import React from 'react';
import { translate } from 'react-polyglot';
import { lengths } from 'netlify-cms-ui-default';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";

const NotFoundContainer = _styled("div", {
  target: "e8enq1s0",
  label: "NotFoundContainer"
})("margin:", lengths.pageMargin, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcC9Ob3RGb3VuZFBhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTW9DIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcC9Ob3RGb3VuZFBhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdHJhbnNsYXRlIH0gZnJvbSAncmVhY3QtcG9seWdsb3QnO1xuaW1wb3J0IHsgbGVuZ3RocyB9IGZyb20gJ25ldGxpZnktY21zLXVpLWRlZmF1bHQnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcblxuY29uc3QgTm90Rm91bmRDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBtYXJnaW46ICR7bGVuZ3Rocy5wYWdlTWFyZ2lufTtcbmA7XG5cbmZ1bmN0aW9uIE5vdEZvdW5kUGFnZSh7IHQgfSkge1xuICByZXR1cm4gKFxuICAgIDxOb3RGb3VuZENvbnRhaW5lcj5cbiAgICAgIDxoMj57dCgnYXBwLm5vdEZvdW5kUGFnZS5oZWFkZXInKX08L2gyPlxuICAgIDwvTm90Rm91bmRDb250YWluZXI+XG4gICk7XG59XG5cbk5vdEZvdW5kUGFnZS5wcm9wVHlwZXMgPSB7XG4gIHQ6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG59O1xuXG5leHBvcnQgZGVmYXVsdCB0cmFuc2xhdGUoKShOb3RGb3VuZFBhZ2UpO1xuIl19 */"));

function NotFoundPage({
  t
}) {
  return ___EmotionJSX(NotFoundContainer, null, ___EmotionJSX("h2", null, t('app.notFoundPage.header')));
}

NotFoundPage.propTypes = {
  t: PropTypes.func.isRequired
};
export default translate()(NotFoundPage);